var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8C6.2352 8 4.8 6.5648 4.8 4.8C4.8 3.0352 6.2352 1.6 8 1.6C9.7648 1.6 11.2 3.0352 11.2 4.8C11.2 6.5648 9.7648 8 8 8ZM11.0064 8.53838C12.0992 7.65918 12.8 6.312 12.8 4.8C12.8 2.1488 10.6512 0 8 0C5.3488 0 3.2 2.1488 3.2 4.8C3.2 6.312 3.9008 7.65918 4.9936 8.53838C2.0664 9.63838 0 12.356 0 16H1.6C1.6 12 4.4712 9.6 8 9.6C11.5288 9.6 14.4 12 14.4 16H16C16 12.356 13.9336 9.63838 11.0064 8.53838Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconSvg);
export default __webpack_public_path__ + "static/media/profile-icon-svg.71e5e563542ce9e10ba8d17f70cae392.svg";
export { ForwardRef as ReactComponent };